<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
    src: string;
    size: 'sm' | 'md' | 'lg';
    overrideRounding?: boolean;
    roundedSide?: 'left' | 'all';
}>();

const sizeClass = computed(() => {
    const base = {
        'w-8 h-8': props.size === 'sm',
        'w-10 h-10': props.size === 'md',
        'w-12 h-12': props.size === 'lg',
    };
    if (props.overrideRounding) {
        return { ...base };
    }
    const rounding = props.roundedSide === 'left'
        ? {
            'rounded-l-md': props.size === 'sm',
            'rounded-l-lg': props.size === 'md' || props.size === 'lg',
          }
        : {
            'rounded-md': props.size === 'sm',
            'rounded-lg': props.size === 'md' || props.size === 'lg',
          };
    return { ...base, ...rounding };
});
</script>

<template>
    <img alt="" :src="props.src" class="object-contain" :class="sizeClass" />
</template>
